module.exports = __webpack_public_path__ + "img/bg.6342dcda.png";